const acfformheroSetup = () => {
  const components = document.querySelectorAll('[data-component-acfform-hero]');

  components.forEach((component) => {
    const header = component.querySelector('.header');
    const heading = header.querySelector('.heading');
    function addCapitalLetterToBackground() {
      const letter = heading.textContent.charAt(0);
      const capital = document.createElement('span');
      capital.innerText = letter;
      capital.classList.add('capital');
      header.prepend(capital);
    }

    addCapitalLetterToBackground();
  });
};

acfformheroSetup();